import { createContext } from 'react';
export var UserContext = /*#__PURE__*/createContext(undefined);